export enum DateFilterOptionsEnum {
  thisMonth = 'THIS_MONTH',
  lastMonth = 'LAST_MONTH', 
  thisYear = 'THIS_YEAR',
  lastYear = 'LAST_YEAR',
  customRange = 'CUSTOM_RANGE'
}